// extracted by mini-css-extract-plugin
export default {"recos":"b2-z","productCardOverride":"c2-z","rowHasBadge":"d2-z"};